import React, { useEffect, useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { setConfirmListener } from "@/lib/confirm";

export default function ConfirmDialog() {
  const [state, setState] = useState(null);

  useEffect(() => {
    setConfirmListener((req) => setState(req));
    return () => setConfirmListener(null);
  }, []);

  const close = (val) => {
    if (state) state.resolve(val);
    setState(null);
  };

  return (
    <Dialog open={!!state} onOpenChange={(v) => !v && close(false)}>
      <DialogContent className="bg-[#FDFCF7] border-[#E8E4D9] sm:max-w-md" data-testid="confirm-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif-display text-2xl text-[#2E332C]">Confirmar</DialogTitle>
          <DialogDescription className="text-base text-[#5C6658] pt-2 whitespace-pre-line">
            {state?.message}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button
            variant="outline"
            onClick={() => close(false)}
            className="rounded-full border-[#E8E4D9] text-[#5C6658]"
            data-testid="confirm-cancel"
          >
            {state?.cancelLabel || "Cancelar"}
          </Button>
          <Button
            onClick={() => close(true)}
            className={`rounded-full text-white ${state?.destructive ? "bg-[#B86B6B] hover:bg-[#8C4848]" : "bg-[#7B8B6F] hover:bg-[#647259]"}`}
            data-testid="confirm-ok"
          >
            {state?.confirmLabel || "Confirmar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
